import "./styles.scoped.css";
export default {
    "dropdown-footer": "awsui_dropdown-footer_vm8qf_jxdvh_5",
    "dropdown-content": "awsui_dropdown-content_vm8qf_jxdvh_10"
};
